import { useEffect } from 'react';
import { scrollToSection } from '../utils/scrollTo';

const useHashScroll = () => {
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const timer = setTimeout(() => scrollToSection(hash), 300);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);
};

export default useHashScroll;